import CryptoJS from 'crypto-js'

const CryptoJSAesJson = {
  stringify(cipherParams: any) {
    const j: any = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
    if (cipherParams.iv)
      j.iv = cipherParams.iv.toString()
    if (cipherParams.salt)
      j.s = cipherParams.salt.toString()
    return JSON.stringify(j)
  },
  parse(jsonStr: any) {
    const j = JSON.parse(jsonStr)
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    })
    if (j.iv)
      cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
    if (j.s)
      cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
    return cipherParams
  },
}

export function encryptJson(text: any, passphrase: string) {
  if (!text || !passphrase)
    return

  try {
    return CryptoJS.AES.encrypt(JSON.stringify(text), passphrase, {
      format: CryptoJSAesJson,
    }).toString()
  }
  catch (e) {
  }
}

export function decryptJson(ciphertext: any, passphrase: string) {
  if (!ciphertext || !passphrase)
    return

  try {
    return JSON.parse(
      CryptoJS.AES.decrypt(ciphertext, passphrase, {
        format: CryptoJSAesJson,
      }).toString(CryptoJS.enc.Utf8),
    )
  }
  catch (e) {
  }
}
